import { Injectable } from '@angular/core';
import {webServiceConfig} from "../config/web-service.config";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class GroupSubTypeProductService {

    constructor(private http: HttpClient) { }
    getSubTypeProducts(TypeProductId: any): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}group-sub-type-products/${TypeProductId}`).pipe(map(response => {
            return response;
        }));
    }
}
